(self['webpackChunkheyholy_ss_theme'] =
  self['webpackChunkheyholy_ss_theme'] || []).push([
  ['/assets/ingredients'],
  {
    /***/ './src/assets/js/ingredients.js'() /*!**************************************!*\
  !*** ./src/assets/js/ingredients.js ***!
  \**************************************/
    {
      function _typeof(o) {
        '@babel/helpers - typeof';
        return (
          (_typeof =
            'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
              ? function (o) {
                  return typeof o;
                }
              : function (o) {
                  return o &&
                    'function' == typeof Symbol &&
                    o.constructor === Symbol &&
                    o !== Symbol.prototype
                    ? 'symbol'
                    : typeof o;
                }),
          _typeof(o)
        );
      }
      function _classCallCheck(a, n) {
        if (!(a instanceof n))
          throw new TypeError('Cannot call a class as a function');
      }
      function _defineProperties(e, r) {
        for (var t = 0; t < r.length; t++) {
          var o = r[t];
          (o.enumerable = o.enumerable || !1),
            (o.configurable = !0),
            'value' in o && (o.writable = !0),
            Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
      }
      function _createClass(e, r, t) {
        return (
          r && _defineProperties(e.prototype, r),
          t && _defineProperties(e, t),
          Object.defineProperty(e, 'prototype', { writable: !1 }),
          e
        );
      }
      function _toPropertyKey(t) {
        var i = _toPrimitive(t, 'string');
        return 'symbol' == _typeof(i) ? i : i + '';
      }
      function _toPrimitive(t, r) {
        if ('object' != _typeof(t) || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
          var i = e.call(t, r || 'default');
          if ('object' != _typeof(i)) return i;
          throw new TypeError('@@toPrimitive must return a primitive value.');
        }
        return ('string' === r ? String : Number)(t);
      }
      function _callSuper(t, o, e) {
        return (
          (o = _getPrototypeOf(o)),
          _possibleConstructorReturn(
            t,
            _isNativeReflectConstruct()
              ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor)
              : o.apply(t, e),
          )
        );
      }
      function _possibleConstructorReturn(t, e) {
        if (e && ('object' == _typeof(e) || 'function' == typeof e)) return e;
        if (void 0 !== e)
          throw new TypeError(
            'Derived constructors may only return object or undefined',
          );
        return _assertThisInitialized(t);
      }
      function _assertThisInitialized(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called",
          );
        return e;
      }
      function _inherits(t, e) {
        if ('function' != typeof e && null !== e)
          throw new TypeError(
            'Super expression must either be null or a function',
          );
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          Object.defineProperty(t, 'prototype', { writable: !1 }),
          e && _setPrototypeOf(t, e);
      }
      function _wrapNativeSuper(t) {
        var r = 'function' == typeof Map ? new Map() : void 0;
        return (
          (_wrapNativeSuper = function _wrapNativeSuper(t) {
            if (null === t || !_isNativeFunction(t)) return t;
            if ('function' != typeof t)
              throw new TypeError(
                'Super expression must either be null or a function',
              );
            if (void 0 !== r) {
              if (r.has(t)) return r.get(t);
              r.set(t, Wrapper);
            }
            function Wrapper() {
              return _construct(
                t,
                arguments,
                _getPrototypeOf(this).constructor,
              );
            }
            return (
              (Wrapper.prototype = Object.create(t.prototype, {
                constructor: {
                  value: Wrapper,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
              _setPrototypeOf(Wrapper, t)
            );
          }),
          _wrapNativeSuper(t)
        );
      }
      function _construct(t, e, r) {
        if (_isNativeReflectConstruct())
          return Reflect.construct.apply(null, arguments);
        var o = [null];
        o.push.apply(o, e);
        var p = new (t.bind.apply(t, o))();
        return r && _setPrototypeOf(p, r.prototype), p;
      }
      function _isNativeReflectConstruct() {
        try {
          var t = !Boolean.prototype.valueOf.call(
            Reflect.construct(Boolean, [], function () {}),
          );
        } catch (t) {}
        return (_isNativeReflectConstruct =
          function _isNativeReflectConstruct() {
            return !!t;
          })();
      }
      function _isNativeFunction(t) {
        try {
          return -1 !== Function.toString.call(t).indexOf('[native code]');
        } catch (n) {
          return 'function' == typeof t;
        }
      }
      function _setPrototypeOf(t, e) {
        return (
          (_setPrototypeOf = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (t, e) {
                return (t.__proto__ = e), t;
              }),
          _setPrototypeOf(t, e)
        );
      }
      function _getPrototypeOf(t) {
        return (
          (_getPrototypeOf = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
                return t.__proto__ || Object.getPrototypeOf(t);
              }),
          _getPrototypeOf(t)
        );
      }
      var IngredientsSection = /*#__PURE__*/ (function (_HTMLElement) {
        function IngredientsSection() {
          var _this;
          _classCallCheck(this, IngredientsSection);
          _this = _callSuper(this, IngredientsSection);
          _this.grid = null;
          _this.cards = [];
          _this.overlays = [];
          _this.resizeTimeout = null;
          _this.onResize = _this.onResize.bind(_this);
          _this.onGridClick = _this.onGridClick.bind(_this);
          // filter elements
          _this.filterDropdown = null;
          _this.filterTitle = null;
          _this.filterInputs = null;
          _this.dropdownTitleEl = null;
          _this.dropdownContentEl = null;
          _this.currentFilter = 'all';
          return _this;
        }
        _inherits(IngredientsSection, _HTMLElement);
        return _createClass(IngredientsSection, [
          {
            key: 'connectedCallback',
            value: function connectedCallback() {
              var _this2 = this;
              setTimeout(function () {
                return _this2.init();
              }, 10);
            },
          },
          {
            key: 'init',
            value: function init() {
              var _this3 = this;
              this.grid = this.querySelector('.ingredients-grid');
              if (!this.grid) return;
              this.cards = Array.from(
                this.querySelectorAll('.ingredient-card'),
              );
              this.overlays = Array.from(
                this.querySelectorAll('.ingredient-overlay'),
              );

              // Open handlers
              this.querySelectorAll('[data-overlay-open]').forEach(function (
                btn,
              ) {
                btn.addEventListener('click', function (e) {
                  e.preventDefault();
                  var card = btn.closest('.ingredient-card');
                  if (!card) return;
                  _this3.showOverlayFromCard(card);
                });
              });

              // Close handlers
              this.querySelectorAll('[data-overlay-close]').forEach(function (
                btn,
              ) {
                btn.addEventListener('click', function (e) {
                  e.preventDefault();
                  _this3.hideOverlays();
                });
              });

              // Outside click (only grid background)
              this.grid.addEventListener('click', this.onGridClick);

              // Resize
              window.addEventListener('resize', this.onResize);

              // Filters
              this.initFilters();
            },
          },
          {
            key: 'disconnectedCallback',
            value: function disconnectedCallback() {
              if (this.grid)
                this.grid.removeEventListener('click', this.onGridClick);
              window.removeEventListener('resize', this.onResize);
            },
          },
          {
            key: 'onGridClick',
            value: function onGridClick(e) {
              if (e.target === this.grid) {
                this.hideOverlays();
              }
            },
          },
          {
            key: 'onResize',
            value: function onResize() {
              var _this4 = this;
              clearTimeout(this.resizeTimeout);
              this.resizeTimeout = setTimeout(function () {
                var visibleOverlay = _this4.querySelector(
                  '.ingredient-overlay:not(.tw-hidden)',
                );
                if (visibleOverlay) {
                  var originalIndex = parseInt(
                    visibleOverlay.getAttribute('data-card-index'),
                  );
                  var cardEl = _this4.querySelector(
                    '.ingredient-card[data-card-index="'.concat(
                      originalIndex,
                      '"]',
                    ),
                  );
                  if (cardEl) _this4.showOverlayFromCard(cardEl);
                }
              }, 250);
            },
          },
          {
            key: 'getGridMetrics',
            value: function getGridMetrics() {
              var style = window.getComputedStyle(this.grid);
              var templateColumns = style.getPropertyValue(
                'grid-template-columns',
              );
              var cols = templateColumns.split(' ').filter(Boolean).length || 1;
              var columnGap =
                parseFloat(style.getPropertyValue('column-gap')) || 0;
              var rowGap =
                parseFloat(style.getPropertyValue('row-gap')) || columnGap;
              // Минимальное число рядов из классов Tailwind (например, tw-grid-rows-2)
              var minRowsFromTemplate = 1;
              var classMatch = (this.grid.className || '').match(
                /tw-grid-rows-(\d+)/,
              );
              if (classMatch && classMatch[1]) {
                var parsed = parseInt(classMatch[1], 10);
                if (!Number.isNaN(parsed) && parsed > 0)
                  minRowsFromTemplate = parsed;
              }

              // размеры берём с ПЕРВОЙ ВИДИМОЙ карточки, иначе getBoundingClientRect() может вернуть 0
              var visibleCards = this.getVisibleCards();
              var probeCard = visibleCards[0] || this.cards[0] || null;
              var cardWidth = 0;
              var cardHeight = 0;
              if (probeCard) {
                var rect = probeCard.getBoundingClientRect();
                cardWidth = rect.width;
                cardHeight = rect.height;
                if ((!cardWidth || !cardHeight) && probeCard.offsetWidth) {
                  cardWidth = probeCard.offsetWidth;
                  cardHeight = probeCard.offsetHeight;
                }
              }

              // Fallback: парсим первую колонку из grid-template-columns, например "185px"
              if (!cardWidth) {
                var firstToken =
                  (templateColumns || '').trim().split(' ')[0] || '';
                var match = firstToken.match(/([0-9]+)px/);
                cardWidth = match ? parseFloat(match[1]) : 185;
              }
              if (!cardHeight) {
                // высоту берём равной ширине карточки (квадратная плитка) либо 185 как дефолт
                cardHeight = cardWidth || 185;
              }
              return {
                cols: cols,
                columnGap: columnGap,
                rowGap: rowGap,
                cardWidth: cardWidth,
                cardHeight: cardHeight,
                minRowsFromTemplate: minRowsFromTemplate,
              };
            },
          },
          {
            key: 'getCardPosition',
            value: function getCardPosition(cardIndex, cols) {
              var row = Math.floor(cardIndex / cols);
              var col = cardIndex % cols;
              return {
                row: row,
                col: col,
              };
            },
          },
          {
            key: 'getVisibleCards',
            value: function getVisibleCards() {
              return Array.from(
                this.querySelectorAll('.ingredient-card'),
              ).filter(function (c) {
                return c.style.display !== 'none';
              });
            },
          },
          {
            key: 'calculateOverlayPositionByCard',
            value: function calculateOverlayPositionByCard(cardEl) {
              var _this$getGridMetrics = this.getGridMetrics(),
                cols = _this$getGridMetrics.cols,
                columnGap = _this$getGridMetrics.columnGap,
                rowGap = _this$getGridMetrics.rowGap,
                cardWidth = _this$getGridMetrics.cardWidth,
                cardHeight = _this$getGridMetrics.cardHeight,
                minRowsFromTemplate = _this$getGridMetrics.minRowsFromTemplate;
              var visibleCards = this.getVisibleCards();
              var visibleIndex = Math.max(0, visibleCards.indexOf(cardEl));
              var position = this.getCardPosition(visibleIndex, cols);

              // Текущее количество строк по контенту и итоговое количество с учётом минимального шаблона
              var contentRows = Math.max(
                1,
                Math.ceil(visibleCards.length / cols),
              );
              var totalRows = Math.max(minRowsFromTemplate, contentRows);
              var gridContentWidth = cols * cardWidth + (cols - 1) * columnGap;
              var gridContentHeight =
                totalRows * cardHeight + (totalRows - 1) * rowGap;

              // Желаемый размер оверлея: 2 колонки × 2 строки (если доступно)
              var spanCols = Math.min(2, cols);
              var spanRows = Math.min(2, Math.max(totalRows, 2));
              var overlayWidth =
                spanCols * cardWidth + (spanCols - 1) * columnGap;
              var overlayHeight =
                spanRows * cardHeight + (spanRows - 1) * rowGap;

              // Начальная позиция: подрезаем, чтобы влезало spanCols/spanRows
              var startCol = Math.max(
                0,
                Math.min(position.col, Math.max(0, cols - spanCols)),
              );
              var startRow = Math.max(
                0,
                Math.min(position.row, Math.max(0, totalRows - spanRows)),
              );
              var left = startCol * (cardWidth + columnGap);
              var top = startRow * (cardHeight + rowGap);

              // Кламп по вычисленным размерам контента грида (а не clientHeight)
              if (left + overlayWidth > gridContentWidth) {
                left = Math.max(0, gridContentWidth - overlayWidth);
              }
              if (top + overlayHeight > gridContentHeight) {
                top = Math.max(0, gridContentHeight - overlayHeight);
              }
              return {
                left: Math.max(0, left),
                top: Math.max(0, top),
                width: overlayWidth,
                height: overlayHeight,
                gridContentHeight: gridContentHeight,
                totalRows: totalRows,
                contentRows: contentRows,
                minRowsFromTemplate: minRowsFromTemplate,
              };
            },
          },
          {
            key: 'showOverlayFromCard',
            value: function showOverlayFromCard(cardEl) {
              // hide all first
              this.overlays.forEach(function (overlay) {
                return overlay.classList.add('tw-hidden');
              });
              var originalIndex = parseInt(
                cardEl.getAttribute('data-card-index'),
              );
              var overlay = this.querySelector(
                '.ingredient-overlay[data-card-index="'.concat(
                  originalIndex,
                  '"]',
                ),
              );
              if (!overlay) return;
              var position = this.calculateOverlayPositionByCard(cardEl);
              overlay.style.left = '';
              overlay.style.top = '';
              overlay.style.width = '';
              overlay.style.height = '';
              overlay.style.position = '';
              overlay.style.transform = '';
              overlay.classList.add('desktop-overlay');
              overlay.classList.remove('mobile-overlay');
              overlay.classList.remove('tw-fixed');
              overlay.classList.add('tw-absolute');
              overlay.style.left = ''.concat(position.left, 'px');
              overlay.style.top = ''.concat(position.top, 'px');
              overlay.style.width = ''.concat(position.width, 'px');
              overlay.style.height = ''.concat(position.height, 'px');
              overlay.classList.remove('tw-hidden');

              // Если фактически только 1 ряд карточек, а сетка задана на 2+, задаём minHeight под оверлей
              var contentRows = position.contentRows,
                minRowsFromTemplate = position.minRowsFromTemplate;
              if (this.grid) {
                if (contentRows < 2 && minRowsFromTemplate >= 2) {
                  this.grid.style.minHeight = ''.concat(position.height, 'px');
                } else {
                  this.grid.style.minHeight = '';
                }
              }
            },
          },
          {
            key: 'hideOverlays',
            value: function hideOverlays() {
              this.overlays.forEach(function (overlay) {
                return overlay.classList.add('tw-hidden');
              });
            },

            // --- Filters ---
          },
          {
            key: 'initFilters',
            value: function initFilters() {
              var _this5 = this;
              this.filterDropdown = this.querySelector(
                'collection-custom-dropdown',
              );
              this.filterTitle = this.querySelector(
                '.collection-custom-dropdown__title-holder',
              );
              this.filterInputs = this.querySelectorAll(
                'input[name="ingredientsFilter"]',
              );
              this.dropdownTitleEl = this.querySelector(
                '.collection-custom-dropdown__title',
              );
              this.dropdownContentEl = this.querySelector(
                '.collection-custom-dropdown__content',
              );
              if (this.dropdownTitleEl && this.dropdownContentEl) {
                // по умолчанию скрываем контент дропдауна, чтобы инпуты не "утекали" в макет
                this.dropdownContentEl.style.display = 'none';
                this.dropdownTitleEl.addEventListener('click', function (e) {
                  e.stopPropagation();
                  _this5.toggleDropdown();
                });
                document.addEventListener('click', function (e) {
                  if (!_this5.contains(e.target)) _this5.closeDropdown();
                });
              }
              this.filterInputs.forEach(function (input) {
                input.addEventListener('change', function (e) {
                  if (e.target.checked) {
                    var filterValue = e.target.value;
                    _this5.setFilter(filterValue);
                    var labelEl = e.target.nextElementSibling;
                    if (labelEl)
                      _this5.updateFilterTitle(labelEl.textContent.trim());
                    _this5.closeDropdown();
                  }
                });
              });
            },
          },
          {
            key: 'updateFilterTitle',
            value: function updateFilterTitle(text) {
              if (this.filterTitle) this.filterTitle.textContent = text;
            },
          },
          {
            key: 'toggleDropdown',
            value: function toggleDropdown() {
              if (!this.filterDropdown || !this.dropdownContentEl) return;
              var isActive = this.filterDropdown.classList.contains(
                'collection-custom-dropdown__content--active',
              );
              if (isActive) this.closeDropdown();
              else this.openDropdown();
            },
          },
          {
            key: 'openDropdown',
            value: function openDropdown() {
              if (!this.filterDropdown || !this.dropdownContentEl) return;
              this.filterDropdown.classList.add(
                'collection-custom-dropdown__content--active',
              );
              this.dropdownContentEl.classList.add('active');
              this.dropdownContentEl.style.display = 'block';
            },
          },
          {
            key: 'closeDropdown',
            value: function closeDropdown() {
              if (!this.filterDropdown || !this.dropdownContentEl) return;
              this.filterDropdown.classList.remove(
                'collection-custom-dropdown__content--active',
              );
              this.dropdownContentEl.classList.remove('active');
              this.dropdownContentEl.style.display = 'none';
            },
          },
          {
            key: 'setFilter',
            value: function setFilter(filterValue) {
              this.currentFilter = filterValue;
              this.filterCards();
            },
          },
          {
            key: 'filterCards',
            value: function filterCards() {
              var _this6 = this;
              var cards = this.querySelectorAll('[data-ingredient-card]');
              cards.forEach(function (card) {
                var ingredientType = card.getAttribute('data-ingredient-type');
                if (
                  _this6.currentFilter === 'all' ||
                  ingredientType === _this6.currentFilter
                ) {
                  card.style.display = '';
                  card.style.animation = 'fadeIn 0.3s ease-in-out';
                } else {
                  card.style.display = 'none';
                }
              });

              // если сейчас открыт оверлей — перепозиционируем относительно новой сетки
              var visibleOverlay = this.querySelector(
                '.ingredient-overlay:not(.tw-hidden)',
              );
              if (visibleOverlay) {
                var originalIndex = parseInt(
                  visibleOverlay.getAttribute('data-card-index'),
                );
                var cardEl = this.querySelector(
                  '.ingredient-card[data-card-index="'.concat(
                    originalIndex,
                    '"]',
                  ),
                );
                if (cardEl && cardEl.style.display !== 'none') {
                  this.showOverlayFromCard(cardEl);
                } else {
                  this.hideOverlays();
                }
              }
            },
          },
        ]);
      })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));
      if (!customElements.get('ingredients-section')) {
        customElements.define('ingredients-section', IngredientsSection);
      }

      /***/
    },
  },
  /******/ (__webpack_require__) => {
    // webpackRuntimeModules
    /******/ var __webpack_exec__ = (moduleId) =>
      __webpack_require__((__webpack_require__.s = moduleId));
    /******/ var __webpack_exports__ = __webpack_exec__(
      './src/assets/js/ingredients.js',
    );
    /******/
  },
]);
